@if (dialogOpen) {
<div class="dialog-bg" [@dialogBg] (click)="close(undefined)"></div>
}
<div *onlyForScreens="['desktop', 'tablet']">
  @if (dialogOpen) {
  <div class="dialog-item" [@dialogContent]>
    <div
      class="dialog-content dialog-content-desktop size-{{ options.size }}"
      [style.min-height]="options.minHeight ? options.minHeight + 'px' : undefined"
    >
      @if (!options.hideClose) {
      <button
        (click)="close(undefined)"
        color="simple-gray"
        appButton
        name="close"
        location="dialogs"
        shape="round"
        [iconButton]="true"
        spacing="1"
        data-test-id="close-dialog-button"
        height="1"
        class="close-button"
      >
        <app-svg src="/assets/icons/cross.svg"></app-svg>
      </button>
      }
      <div
        class="dialog-inner-content dialog-inner-content-desktop size-{{ options.size }} spacing-x-{{
          options.spacingX
        }} spacing-y-{{ options.spacingY }}"
        [class.small-bottom]="options.hasSmallBottomPart"
      >
        <ng-container *ngTemplateOutlet="template"></ng-container>
      </div>
    </div>
  </div>
  }
</div>
<div *onlyForScreens="['mobile']">
  @if (dialogOpen && options.mobileAlignment !== 'top') {
  <div class="dialog-item dialog-item-mobile" [style.max-height]="maxHeight + 'px'" [@dialogContentMobile]>
    <div class="dialog-content size-{{ options.size }}">
      <div
        class="dialog-inner-content size-{{ options.size }} spacing-x-{{ options.spacingX }} spacing-y-{{
          options.spacingY
        }}"
        [class.small-bottom]="options.hasSmallBottomPart"
        [style.max-height]="maxHeight + 'px'"
      >
        <ng-container *ngTemplateOutlet="template"></ng-container>
      </div>
    </div>
  </div>
  } @if (dialogOpen && options.mobileAlignment === 'top') {
  <div class="dialog-item dialog-item-mobile top" [style.max-height]="maxHeight + 'px'" [@dialogContentMobileTop]>
    <div class="dialog-content size-{{ options.size }}">
      <div
        class="dialog-inner-content size-{{ options.size }} spacing-x-{{ options.spacingX }} spacing-y-{{
          options.spacingY
        }}"
        [class.small-bottom]="options.hasSmallBottomPart"
        [style.max-height]="maxHeight + 'px'"
      >
        <ng-container *ngTemplateOutlet="template"></ng-container>
      </div>
    </div>
  </div>
  }
</div>
<ng-template #template>
  <ng-template #placeholder></ng-template>
</ng-template>
